import TagManager from 'react-gtm-module';

/**
 * Envía datos al dataLayer de GTM.
 * @param {string} event   – Nombre del evento (p. ej. "step_view")
 * @param {object} params  – Pares clave-valor adicionales
 */

export function pushDataLayer(event, params = {}) {

  if (window?.dataLayer) {
    TagManager.dataLayer({
      dataLayer: { event, ...params },
    });
  }
}
